<script lang="ts">
	import { createEventDispatcher } from "svelte";
	import { Button, Col, FormGroup, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Popover, Row } from "sveltestrap";
    import type { RegisterInOut } from "../Model/RegisterInOut";
	import { containsService, directionsService, fileServices, paramsService, procedencesService, recordsIntoOutService, thirdsService, usersService, writeFileService } from "../services";
    import { dateInputFormatter } from "../services/Functions";
    import ContainSelect from "./containSelect.svelte";
    import ParamSelect from "./ParamSelect.svelte";
    import ProcedentSelect from "./procedentSelect.svelte";
    import ThirdNameInput from "./ThirdNameInput.svelte";
	import type { Third } from "../Model/Third";
    import { REGISTERSINTOOUT } from "../evironment";
	import { writable } from "svelte/store";
    import AddThirdList from "./AddThirdList.svelte";
    import type { User } from "../Model/User";

	const dispatch = createEventDispatcher();

	$: user();

	let changeThird = false;
	let buttonIn = true;
	let buttonOut = true;
	let deleteIn, deleteOut = false;
	let files: any[] = [];
	let currentUser: User;

	async function user() {
		currentUser = await usersService.findActualUser();
	}

	async function changeThirdEvent(third){
    	register.thirdId = third.id;
    	changeThird = false;
    	dispatch("changeThirdLIst", third);
  	}

	let size = 'lg';
	let open = false;
    let booleanChangeThird = false;
	let pop = false;
	const delay = (ms: any | undefined) => new Promise(res => setTimeout(res, ms));

	export let register: RegisterInOut = null;
	export let newRegister: boolean = false;

	$: open = !!register; 

	const toggle = () => {
	  size = 'lg';
	  open = !open;
	};

	async function save(){ 
		await saveRegister();
		dispatch("registerUpdate", register);
	}

	

	async function saveRegister(){
		return await recordsIntoOutService.saveRegisters(register);
	}

	function changeThirdRegister(thirdId:string) {
		register.thirdId = thirdId;
	}

	async function generateInput(type:string,visibility:boolean) {
		if (type == 'in') {
			let inReg = document.querySelector('#inReg');
			let inDate = document.querySelector('#inDate');
			
			if (visibility) {
				inReg.disabled = visibility;
				inDate.disabled = visibility;
				buttonIn = visibility;
				deleteIn = false;

				register.inRegisterNumber = null;
				register.inDate = null;
			} else {
				inReg.disabled = visibility;
				inDate.disabled = visibility;
				buttonIn = visibility;
			 	deleteIn = true;

				register.inRegisterNumber = parseInt(await recordsIntoOutService.lastInRegister(new Date().getFullYear()));
				register.inDate = new Date();
			}
		} else if (type == 'out') {
			let outReg = document.querySelector('#outReg');
			let outDate = document.querySelector('#outDate');
			let outTime = document.querySelector('#outTime');
			
			if (visibility) {
				outReg.disabled = visibility;
				outDate.disabled = visibility;
				buttonOut = visibility;
				deleteOut = false;

				register.outRegisterNumber = null;
				register.outDate = null;
			} else {
				outReg.disabled = visibility;
				outDate.disabled = visibility;
				buttonOut = visibility;
			 	deleteOut = true;

				register.outRegisterNumber = parseInt(await recordsIntoOutService.lastOutRegister(new Date().getFullYear()));
				register.outDate = new Date();
			}
		}
	}

	async function download(fileId: string) {
		try {
			await writeFileService.writeInOutFile(register, fileId);
		} catch(error) {
			console.log(error);
		}
	}

	async function chooseFile() {
		try {
			files = await fileServices.findFilesByContext(REGISTERSINTOOUT);
		} catch(error) {

		}
	}

  </script>

  
	<Modal isOpen={open} {toggle} {size}>
	  	<ModalHeader {toggle}>Editar Registro De Entrada/Salida</ModalHeader>
	  	<ModalBody>
			<Row>
				<Col xs="7">
					<FormGroup>
						<Label for="exampleEmail">Registro de entrada</Label>
						<Input
							id='inReg'
							disabled
						  	type="text"
						  	bind:value={register.inRegisterNumber}
						/>
					</FormGroup>
                </Col>
                <Col xs="4">
					<FormGroup>
						<Label for="exampleEmail">Fecha de entrada</Label>
						<Input
							id='inDate'
							disabled
                            type="date"
                            value={dateInputFormatter(register.inDate)}  
                            on:change={(event)=>register.inDate = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs='1'>
						<FormGroup>
							{#if buttonIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('in',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteIn}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('in',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
                <Col xs="7">
                    <FormGroup>
						<Label for="exampleEmail">Registro de Salida</Label>
						<Input
							id='outReg'
							disabled
						  	type="text"
						  	bind:value={register.outRegisterNumber}
						/>
					</FormGroup>
                </Col>
                <Col xs="4">
                    <FormGroup>
						<Label for="exampleEmail">Fecha de salida</Label>
						<Input
							id='outDate'
							disabled
						    type="date"
                            value={dateInputFormatter(register.outDate)}  
                            on:change={(event)=>register.outDate = event.currentTarget.value}
						/>
					</FormGroup>
                </Col>
				{#if currentUser.type.id == 4 || currentUser.type.id == 3 || newRegister}
					<Col xs='1'>
						<FormGroup>
							{#if buttonOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('out',false)}>
									<Icon name='pencil' />
								</Button>
							{/if}
							{#if deleteOut}
								<Button
									class='mt-4 mb-3'
									color="primary" 
									on:click={() => generateInput('out',true)}>
									<Icon name='x-lg' />
								</Button>
							{/if}
						</FormGroup>
					</Col>
				{/if}
                <Col xs="6">
                    <FormGroup>
						<Label for="exampleEmail">Procedencia</Label>
						<ProcedentSelect bind:procedenceSelectId={register.origin} />
					</FormGroup>
                </Col>
                <Col xs="6">
                    <FormGroup>
						<Label for="exampleEmail">Destinatario</Label>
						<ProcedentSelect bind:procedenceSelectId={register.destination} />
					</FormGroup>
                </Col>
                <Col xs="12">
                    <FormGroup>
						<Label for="exampleEmail">Solicita</Label>
						<Input
                            type="textarea"
                            rows={6}
						    bind:value={register.request}
						/>
					</FormGroup>
                </Col>
                <Col xs="4">
                    <FormGroup>
						<Label for="exampleEmail">Agente</Label>
                        <ParamSelect
                            bind:paramSelectId = {register.agentId}
                            paramType = 'agentList'
                            nothing = {true}
                        />
					</FormGroup>
                </Col>
                <Col xs="8">
					<FormGroup>
						<Label for="exampleEmail">Tercero</Label>
						<div class="input-group w-100">
							<ThirdNameInput id={register.thirdId} />
							<button
								class="btn btn-secondary"
								type="button"
								id="complainantThirId"
								name="complainantThirId"
								on:click={() => {if(changeThird){changeThird = false} else {changeThird = true}}}
							>
								<Icon name="plus" />
							</button>
						</div>

						{#if changeThird}
							<div class="m-3 p-2 border rounded third-box-modal">
								<h5>Busqueda de Terceros</h5>
          						<AddThirdList on:changeThird={(event) => changeThirdEvent(event.detail)} />
								<div class='text-end mt-2'>
									<a href="/tercero/new" class='btn btn-success text-white text-decoration-none' target='_blank'>Crear tercero</a>
								</div>
							</div>
						{/if}
					</FormGroup>
                </Col>
                <Col xs="12">
                    <FormGroup>
						<Label for="exampleEmail">Informe</Label>
						<Input
                            type="textarea"
                            rows={6}
						    bind:value={register.report}
						/>
					</FormGroup>
                    <FormGroup>
						<Label for="exampleEmail">Contenido</Label>
                        <ContainSelect bind:containSelectId={register.content} module='Registro General de Entrada y Salida'/>
					</FormGroup>
                </Col>
                <Col xs="4">
                    <FormGroup>
						<Label for="exampleEmail">Bloqueo de salida</Label>
                        <Input 
                            type="checkbox" 
                            label="Bloqueado"  
                            bind:checked={register.outPutLock}
                        />
					</FormGroup>
                </Col>
                <Col xs="8">
                    <FormGroup>
						<Label for="exampleEmail">Número de expediente</Label>
						<Input
						  type="text"
						  bind:value={register.fileNumber}
						/>
					</FormGroup>
                </Col>
			</Row>

	  	</ModalBody>
	  	<ModalFooter>
			<Button color='success' id="btnDismissible" on:click={() => {chooseFile(); pop == false ? pop = true : pop = false}}>Descargar documento</Button>
			{#if pop}
				<div class='pop bg-white shadow-lg rounded-3 border border-1' >
					<div class='bg-light p-2 border- border-bottom'>
						Seleccione un fichero
					</div>
					<div class='p-4 d-flex flex-column'>
						{#if files.length > 0}
							{#each files as file}
								<button class='btn btn-secondary mb-2 fs-6' on:click={async() => {download(file.id); await delay(500).then(() => pop = false) }}>{file.name}</button>
							{/each}
						{:else}
							<span>No hay ficheros para descargar</span>
						{/if}
					</div>
				</div>
			{/if}
			<Button color="primary" on:click={() => {save()}}>Guardar</Button>
	  	</ModalFooter>
	</Modal>

	<style>
		.pop {
			position: absolute;
			bottom: 60px;
			right: 100px;
			width: auto;
		}
	</style>